export default "__VITE_PUBLIC_ASSET__7ccb3e4b__"